import { module } from 'angular';
import cardGridComponent from './card-grid.component';
import './card-grid.scss';

export default module('app')
	.component('cardGrid', cardGridComponent)
	.name;
